import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import ResepObatSvc from "@/services/ResepObat";
import {
  RefSatuanDosis,
  RefAturanTambahan
} from "@/utils/resepTerstruktur";

interface RefData {
  id: string | number;
  nama: string;
  [kunci: string]: any;
}

@Module({ store, dynamic: true, name: "referensi-resep", namespaced: true })
class ReferensiResep extends VuexModule {
  public refRute: RefData[] = [];
  public refFrekuensi: RefData[] = [];
  public refSediaan: RefData[] = [];
  public refSatuanDosis: RefSatuanDosis[] = [];
  public refAturanTambahan: RefAturanTambahan[] = [];

  @Mutation
  public SET_RUTE(data: RefData[]): void {
    this.refRute = data;
  }

  @Action
  public getRefRute(): void {
    ResepObatSvc.getRefRute().then(data => {
      this.SET_RUTE(data.data);
    });
  }

  @Mutation
  public SET_FREKUENSI(data: RefData[]): void {
    this.refFrekuensi = data;
  }

  @Action
  public getRefFrekuensi(): void {
    ResepObatSvc.getRefFrekuensi().then(data => {
      this.SET_FREKUENSI(data.data);
    });
  }

  @Mutation
  public SET_SEDIAAN(data: RefData[]): void {
    this.refSediaan = data;
  }

  @Action
  public getRefSediaan(): void {
    ResepObatSvc.getRefSediaan().then(data => {
      this.SET_SEDIAAN(data.data);
    });
  }

  @Mutation
  public SET_SATUAN_DOSIS(data: RefSatuanDosis[]): void {
    this.refSatuanDosis = data;
  }

  @Action
  public getRefSatuanDosis(): void {
    ResepObatSvc.getRefSatuanDosis().then(data => {
      this.SET_SATUAN_DOSIS(data.data);
    });
  }

  @Mutation
  public SET_ATURAN_TAMBAHAN(data: RefAturanTambahan[]): void {
    this.refAturanTambahan = data;
  }

  @Action
  public getRefAturanTambahan(): void {
    ResepObatSvc.getRefAturanTambahan().then(data => {
      this.SET_ATURAN_TAMBAHAN(data.data);
    });
  }
}

export const refResepStore = getModule(ReferensiResep);
